import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, UrlTree, CanDeactivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SubmitApplicationComponent } from './submit-application/submit-application.component';
import { ApplicationDataCaptureService } from '../../../shared';

@Injectable({
  providedIn: 'root'
})
export class CreateApplicationSubmittedCanDeativeatedGuardGuard implements CanDeactivate<SubmitApplicationComponent>  {
constructor(private applicationDataService: ApplicationDataCaptureService,
            private router: Router) {}

canDeactivate(): boolean {
  if (this.applicationDataService.getBackClicked()) {
    this.applicationDataService.setBackClicked(false);
    this.router.navigate(['/quote/your-saved-quotes']);
    return false;
  } else {
    return true;
  }
}
}
